/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    func, string, object,
    arrayOf, shape, number,
} from 'prop-types';
import { connect } from 'react-redux';

import withStyles from '@material-ui/core/styles/withStyles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import SubscriptionSummary from './SubscriptionSummary';
import configENV from '../../../config';
import { isEmpty } from '../../../utils/object';

const { PERSIST_KEY } = configENV;

const styles = () => ({
    list: {
        color: '#333',
    },
    card: {
        backgroundColor: '#fffff8',
        marginBottom: '20px',
        boxShadow: '0 3px 6px rgba(0,0,0,.16), 0 3px 6px rgba(0,0,0,.23)',
    },
    cardContent: {
        padding: '7px',
    },
});

function SubscriptionList({ subscriptions, handleSelect, classes }) {
    if (!subscriptions) {
        return null;
    }
    if (isEmpty(subscriptions)) {
        return <div>You have no product subscriptions</div>;
    }
    return (
        <div className={classes.list}>
            {subscriptions.map((subscription) => (
                <Card className={classes.card} onClick={() => handleSelect(subscription.ruleId)} key={subscription.ruleId}>
                    <CardContent className={classes.cardContent}>
                        <SubscriptionSummary subscription={subscription} includeArrow />
                    </CardContent>
                </Card>
            ))}
        </div>
    );
}

SubscriptionList.defaultProps = {
    subscriptions: [],
    handleSelect: () => {},
};

SubscriptionList.propTypes = {
    subscriptions: arrayOf(
        shape({
            checkoutBrand: string,
            duration: number.isRequired,
            endDate: string.isRequired,
            interval: number.isRequired,
            nextOrderDate: string,
            orderDate: string.isRequired,
            orderHistoryResult: arrayOf(
                shape({
                    deliveryDate: string,
                    discountAmount: string,
                    orderDate: string.isRequired,
                    orderNumber: string.isRequired,
                    productCode: string.isRequired,
                    productName: string.isRequired,
                    productPrice: string.isRequired,
                    quantity: string.isRequired,
                }),
            ),
            orderNumber: string.isRequired,
            orderTime: string.isRequired,
            orderType: string.isRequired,
            price: string.isRequired,
            productId: string.isRequired,
            productImageCategory: string.isRequired,
            productImageThumbnail: string.isRequired,
            productName: string.isRequired,
            quantity: string,
            recipient: arrayOf(shape({
                city: string.isRequired,
                country: string.isRequired,
                firstName: string.isRequired,
                lastName: string.isRequired,
                state: string.isRequired,
                street1: string.isRequired,
                street2: string.isRequired,
                zipcode: string.isRequired,
            })),
            ruleId: string.isRequired,
            startDate: string.isRequired,
            subscriptionStatus: string.isRequired,
            totalAmount: string.isRequired,
        }),
    ),
    handleSelect: func,
    classes: object.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        subscriptions: newState.subscriptions,
        toggleState: newState.toggleState,    // hack to force a refresh
    };
};

export default connect(
    mapStateToProps,
    null,
)(withStyles(styles, { withTheme: true })(SubscriptionList));
